// extracted by mini-css-extract-plugin
export default {"icon":"IRJANDI7wN","hint":"vyan_XXJ13"};